import { render, staticRenderFns } from "./LogoutIcon.vue?vue&type=template&id=445e29a3&scoped=true&"
import script from "./LogoutIcon.vue?vue&type=script&lang=js&"
export * from "./LogoutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e29a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445e29a3')) {
      api.createRecord('445e29a3', component.options)
    } else {
      api.reload('445e29a3', component.options)
    }
    module.hot.accept("./LogoutIcon.vue?vue&type=template&id=445e29a3&scoped=true&", function () {
      api.rerender('445e29a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/LogoutIcon.vue"
export default component.exports